// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  elements: Array<string | { name: string, to: string }>,
  isDark?: boolean,
  breadcrumbStyle?: string,
  isPagePartenaireHeader?: boolean
};

class Breadcrumb extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    elements: []
  };

  renderElements = (elements: Array<string | { name: string, to: string }>): any => {
    return elements.map((el, index) => <li key={index}>{this.renderElement(el)}</li>);
  };

  renderElement = (element: string | { name: string, to: string }) => {
    return typeof element === 'string' ? element : this.renderLink(element.name, element.to);
  };

  renderLink = (name: string, to: string) => {
    const { isPagePartenaireHeader } = this.props;

    if (isPagePartenaireHeader === true) {
      return (
        <a href={to} title={`Se rendre à la page ${name}`} role="button" tabIndex={0}>
          {name}
        </a>
      );
    } else {
      return (
        <Link to={to} title={`Se rendre à la page ${name}`} role="button" tabIndex={0}>
          {name}
        </Link>
      );
    }
  };

  render() {
    const classNamesBreadcrumb = dynamicClassName('breadcrumb ft-h6 ft-up');
    this.props.breadcrumbStyle !== '' && classNamesBreadcrumb.add(this.props.breadcrumbStyle);
    this.props.isDark === true && classNamesBreadcrumb.add('is-dark');
    return <ol className={classNamesBreadcrumb.build()}>{this.renderElements(this.props.elements)}</ol>;
  }
}
export default Breadcrumb;
